import Vue from 'vue/dist/vue.min.js';
import VModal from 'vue-js-modal';
import {patentsModal} from './modals';

Vue.use(VModal);

const patents = () => {

    let patentItems = document.querySelectorAll('.patents');

    let patentsConstructor = (id) => {
        Vue.component('patents', {
            data: function() {
                return {
                   allPatents: null
                }
            },
            methods: {
                triggerModal() {
                    this.$modal.show(
                        patentsModal.template,
                        patentsModal.name, 
                        patentsModal.options,
                        patentsModal.events(this.allPatents)
                    )
                }
            },
            mounted() {
              this.$nextTick(() => {
                this.allPatents = this.$refs.allPatents;
              });
            }
        });

        new Vue({
            el: `.patents-${id}`,
        }).$mount(`.patents-${id}`, true);
    }

    if (patentItems.length > 0) {
        patentItems.forEach((item, index) => {
            item.classList.add(`patents-${index}`);
            patentsConstructor(index);
        })
    }

}

export default patents;